import clsx from "clsx";
import type { ReactNode } from "react";

interface Props {
  label: ReactNode;
  value: ReactNode;
  color?: "default" | "accent";
}

export const PaymentDetailsRow = ({
  label,
  value,
  color = "default",
}: Props) => {
  return (
    <>
      <dt className="text-text-tertiary">{label}</dt>
      <dd
        className={clsx("text-end font-medium", {
          "text-core-accent-500": color === "accent",
          "text-text-primary": color === "default",
        })}
      >
        {value}
      </dd>
    </>
  );
};
